import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toArray, omit } from 'lodash';
import MediaQuery from 'react-responsive';

import { PATH } from '../../constants/path';
import { hasCoupon } from '../../services/partner/utils';
import LocalizedNavLink from '../router/LocalizedNavLink';
import { clearFilter } from '../../services/filter/actions';
import { SUB_NAV_CATEGORIES } from '../../services/nav/constants';
import { showSubNav, hideSubNav } from '../../services/nav/actions';
import CategoriesSubNavComponent from './CategoriesSubNavComponent';
import { MENU_VERSION_MENU_MOBILE_SLIDE } from '../../services/header/constants';

import './NavComponent.scss';

class MenuComponent extends React.Component {
    showSubNav = subNav => this.props.showSubNav(subNav);
    hideSubNav = () => this.props.hideSubNav();

    onMouseEnterCategories = () => this.showSubNav(SUB_NAV_CATEGORIES);
    onMouseLeaveCategories = () => this.hideSubNav();

    makeOnMouseEnterCategories = matches => (matches ? this.onMouseEnterCategories : null);
    makeOnMouseLeaveCategories = matches => (matches ? this.onMouseLeaveCategories : null);

    makeOnClickCategories = () => {
        this.props.clearFilter('directory');
    };

    render() {
        const {
            i18n,
            stateOpenMenuMobileSlide,
            versionOpenMenuMobileSlide,
            categories,
            partners
        } = this.props;

        const showCoupon = partners && partners.filter(partner => hasCoupon(partner)).length > 0;

        return (
            <nav
                className={`menu menu-mobile-slide ${
                    stateOpenMenuMobileSlide &&
                    versionOpenMenuMobileSlide === MENU_VERSION_MENU_MOBILE_SLIDE
                        ? 'open'
                        : ''
                }`}
                id="menu">
                <div className="conteneur menu-conteneur flex-container-h">
                    <LocalizedNavLink to="/" activeClassName="actif" exact>
                        {i18n.accueil}
                    </LocalizedNavLink>
                    <LocalizedNavLink to={PATH.HOW_IT_WORK_PATH} activeClassName="actif">
                        {i18n.commentcamarche}
                    </LocalizedNavLink>
                    <MediaQuery query="(min-width: 769px)">
                        {matches => (
                            <LocalizedNavLink
                                to={PATH.CASHBACK_MOST_POPULAR_PATH}
                                activeClassName="actif"
                                className="menu-sous-menu"
                                onMouseEnter={this.makeOnMouseEnterCategories(matches)}
                                onMouseLeave={this.makeOnMouseLeaveCategories(matches)}
                                onClick={this.makeOnClickCategories.bind(this)}>
                                {i18n.nosrubriques}
                            </LocalizedNavLink>
                        )}
                    </MediaQuery>
                    <CategoriesSubNavComponent categories={categories} />
                    {showCoupon && (
                        <LocalizedNavLink
                            to={PATH.REDUCTION_MOST_POPULAR_PATH}
                            activeClassName="actif">
                            {i18n.codesdereduction}
                        </LocalizedNavLink>
                    )}
                    <LocalizedNavLink to={PATH.SPONSORSHIP_PATH} activeClassName="actif">
                        {i18n.sponsorship}
                    </LocalizedNavLink>
                    <LocalizedNavLink to={PATH.CONTACTREQUEST_PATH} activeClassName="actif">
                        {i18n.contact}
                    </LocalizedNavLink>
                </div>
            </nav>
        );
    }
}

MenuComponent.propTypes = {
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        stateOpenMenuMobileSlide: state.header.stateOpenMenuMobileSlide,
        versionOpenMenuMobileSlide: state.header.versionOpenMenuMobileSlide,
        i18n: state.i18n.feature.header.menu,
        categories: toArray(omit(state.category.categories, 'loading')),
        subNavDisplayed: !!state.nav.subNav,
        partners: toArray(state.partner.partners)
    };
};

const mapDispatchToProps = {
    showSubNav,
    hideSubNav,
    clearFilter
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuComponent);



// WEBPACK FOOTER //
// ./src/components/header/NavComponent.js